import React from 'react';

import { SxProps } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

import { StudentActivityAnswer } from '@ts-core/modules/activities/types';

import ActivityBaseMessage from '../ActivityBaseMessage';

interface ActivityResultProps {
  sx?: SxProps;

  answer?: StudentActivityAnswer;
  loading?: boolean;

  onDeleteScore?: () => void;
  onDeleteFeedback?: () => void;
}

const ActivityResult = (props: ActivityResultProps) => {
  const { answer, loading, onDeleteScore, onDeleteFeedback, sx } = props;

  const feedback = answer?.feedback;

  return (
    <Stack sx={sx} spacing={2}>
      {!!answer?.feedback && (
        <ActivityBaseMessage
          mode="professor"
          title={feedback?.createdBy?.name}
          text={feedback?.text}
          file={feedback?.file}
          date={feedback?.createdAt}
          loading={loading}
          deleteAlertMessage="¿Seguro de que deses eliminar la devolución?"
          onDelete={onDeleteFeedback}
        />
      )}
      {!!answer?.score && (
        <ActivityBaseMessage
          mode="professor"
          title={answer?.gradedBy?.name}
          text={`<p>Puntaje: <strong>${answer?.score}</strong></p>`}
          date={answer?.gradedAt}
          loading={loading}
          deleteAlertMessage="¿Seguro de que deses eliminar el puntaje?"
          onDelete={onDeleteScore}
        />
      )}
    </Stack>
  );
};

export default ActivityResult;
